




























































// Data and util imports
import codes from 'highered-utils/data/codes.json';
import StateEnum from '~/utils/StateEnum';
import splitFullPhoneNumber from '~/utils/splitFullPhoneNumber';
import { emailValidator } from '~/utils/validators';

// Components
import ContactDetailsSkeleton from '../skeletons/ContactDetailsSkeleton.vue';
import Vue, { PropType } from 'vue';
import { User } from '~/services/IdentityService';

export default Vue.extend({
    name: 'ContactDetails',
    components: { ContactDetailsSkeleton },
    props: {
        value: {
            type: Object as PropType<User>,
            required: true,
        },
        oldUserData: {
            type: Object as PropType<User>,
            required: true,
        },
        isLoading: Boolean,
    },
    data: () => ({
        countryCodes: codes,
        countryCode: null,
        phoneNumber: '',
        StateEnum: StateEnum,
        emailErrorMessage: '',
    }),
    methods: {
        handleCountryCodeChange(newVal: any): void {
            this.countryCode = newVal;
            this.emitValue();
        },
        handlePhoneNumberChange(newVal: string): void {
            this.phoneNumber = newVal;
            this.emitValue();
        },
        countryCodeToString(code: any): String {
            return code ? ''.concat(code.label, ' ') : '';
        },
        emitValue(): void {
            this.$emit('input', {
                ...this.value,
                phoneNumber: this.countryCodeToString(this.countryCode).concat(this.phoneNumber),
            });
        },
        splitFullPhoneNumber(fullPhoneNumber: any | undefined): void {
            const phoneNumbInfo = splitFullPhoneNumber(fullPhoneNumber, this.countryCodes);
            this.countryCode = phoneNumbInfo.code;
            this.phoneNumber = phoneNumbInfo.phoneNumber || '';
        },
        handleEmailChange(email: string): void {
            this.emailErrorMessage = '';
            let user = Object.assign({}, this.value);
            user.email = email;
            this.$emit('input', user);
        },
        isValidEmail(): Boolean {
            if (!!this.value.email) {
                return emailValidator(this.value.email);
            }
            return false;
        },
        validateEmail(): void {
            if (!this.isValidEmail()) {
                this.emailErrorMessage = this.$t('spotlight.contactDetails.invalidEmail') as string;
            }
        },
    },
    mounted(): void {
        this.splitFullPhoneNumber(this.value.phoneNumber);
    },
    watch: {
        value(newUser: User): void {
            this.splitFullPhoneNumber(newUser.phoneNumber);
        },
    },
});
